import React from 'react';
import classNames from 'classnames';

// Types
import { WrapperProps } from '../../types/layout/wrapper';

export const Wrapper = ({
  size,
  addFlow,
  children,
  className,
  addAlignStretch,
}: WrapperProps) => (
  <div
    data-flush={size === 'flush' ? '' : undefined}
    data-size={size !== 'flush' ? size : undefined}
    className={classNames('wrapper', {
      flow: addFlow,
      [`${className}`]: className,
      'align-stretch': addAlignStretch,
    })}
  >
    {children}
  </div>
);
